import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListSideComponent } from './list-side.component';
import { BadgeModule } from '../badge/badge.module';

@NgModule({
  declarations: [ListSideComponent],
  imports: [CommonModule, BadgeModule],
  exports: [ListSideComponent],
})

export class ListSideModule {}
